export default "__VITE_ASSET__D6MAOU$M__"